import { render } from "./SustainabilityReporting.vue?vue&type=template&id=0a94c157&scoped=true"
import script from "./SustainabilityReporting.vue?vue&type=script&lang=js"
export * from "./SustainabilityReporting.vue?vue&type=script&lang=js"

import "./SustainabilityReporting.vue?vue&type=style&index=0&id=0a94c157&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a94c157"]])

export default __exports__